import { initIDB } from "./";

export const indexedDbGetById = (dbName: string, id: unknown) => {
  return new Promise((resolve) => {
    // (resolve, reject)
    initIDB().then((db) => {
      const txn = (db as any).transaction(dbName, "readonly");
      const store = txn.objectStore(dbName);
      const query = store.get(id);
      query.onsuccess = function (event: Event) {
        if (!(event.target as any).result) {
          resolve(null);
        } else {
          resolve((event.target as any).result);
        }
      };
      query.onerror = function () {
        // event
        resolve(null);
      };
      txn.oncomplete = function () {
        (db as any).close();
      };
    });
  });
};
